import React, { createContext, useContext, useEffect, useState } from 'react';

const StateContextInfo = createContext();

export const ContextProviderInfo = ({ children }) => {
    const [toastCh, setToast] = useState(false);
    const [dataToas, setDtToas] = useState({
        tipo: 'success',
        sms: [
            {
                value: '',
                msg: 'El nombre es obligatorio',
                param: 'nodo',
                location: 'body',
            },
            { value: '', msg: 'La ip es obligatoria', param: 'ip', location: 'body' },
        ],
    });
    const [coords, setCoords] = useState([]);
    const [respuesta, setResp] = useState();
    useEffect(() => {
        loadResp();
    }, [respuesta]);
    const loadResp = () => {
        if (respuesta) {
            if (respuesta.ok) {
                setDtToas({ tipo: 'success', sms: [{ ...respuesta }] });
                setToast(true);
            }
            if (!respuesta.ok) {
                setDtToas({ tipo: 'error', sms: [{ ...respuesta }] });
                setToast(true);
            }

            if (respuesta.errors) {
                setDtToas({ tipo: 'error', sms: [...respuesta.errors] });
                setToast(true);
            }
        }
    };
    return (
        <StateContextInfo.Provider
            value={{
                toastCh,
                setDtToas,
                setToast,
                dataToas,
                setCoords,
                coords,
                respuesta,
                setResp,
            }}>
            {children}
        </StateContextInfo.Provider>
    );
};

export const useContextInfo = () => useContext(StateContextInfo);
